import { render, staticRenderFns } from "./DistrictDialog.vue?vue&type=template&id=388ec494"
import script from "./DistrictDialog.vue?vue&type=script&lang=ts"
export * from "./DistrictDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports